import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ENVIRONMENT_TOKEN } from '../injection-tokens/environment.token';

export interface HttpOptions {
  headers?: HttpHeaders | Record<string, string | string[]>;
  params?:
    | HttpParams
    | Record<string, string | number | boolean | ReadonlyArray<string | number | boolean>>;
  withCredentials?: boolean;
}

export abstract class BaseApiService {
  protected environment = inject(ENVIRONMENT_TOKEN);
  protected http = inject(HttpClient);

  private _prepareOptions(options?: HttpOptions): HttpOptions {
    if (!options) {
      options = {
        headers: {},
      };
    }

    if (options.withCredentials === undefined) {
      options.withCredentials = true;
    }

    return options;
  }

  protected get<T>(resource: string, options?: HttpOptions): Observable<T> {
    return this.http.get<T>(
      `${this.environment.baseApiUrl}/${resource}`,
      this._prepareOptions(options)
    );
  }

  protected post<T>(resource: string, data?: unknown, options?: HttpOptions): Observable<T> {
    return this.http.post<T>(
      `${this.environment.baseApiUrl}/${resource}`,
      data,
      this._prepareOptions(options)
    );
  }

  protected put<T>(resource: string, data?: unknown, options?: HttpOptions): Observable<T> {
    return this.http.put<T>(
      `${this.environment.baseApiUrl}/${resource}`,
      data,
      this._prepareOptions(options)
    );
  }

  protected patch<T>(resource: string, data?: unknown, options?: HttpOptions): Observable<T> {
    return this.http.patch<T>(
      `${this.environment.baseApiUrl}/${resource}`,
      data,
      this._prepareOptions(options)
    );
  }

  protected delete<T>(resource: string, options?: HttpOptions): Observable<T> {
    return this.http.delete<T>(
      `${this.environment.baseApiUrl}/${resource}`,
      this._prepareOptions(options)
    );
  }
}
